module.exports = __webpack_public_path__ + "static/img/140_TO8_1839.80974fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/140_TO8_1839.jpg
// module id = ohfq
// module chunks = 0